// src/registered/site-admin/components/Workflow-esg/services/SustinaXbrlProcessorService.js
import { executeWorkflowHandshake } from "../Workflow_XLS_Support";

// Fixed destination for ingested taxonomy catalogues - see Session 1/2 notes.
const TAXONOMY_BUCKET = "esg-taxonomy-reference";

// Turns a taxonomy entry-point URL into a stable, readable S3 key so the same
// taxonomy always lands in the same place on re-ingest (e.g. after a refresh).
function slugFromEntryPointUrl(url) {
  return url
    .replace(/^https?:\/\//i, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase()
    .slice(0, 180);
}

/**
 * Ingests a real XBRL taxonomy package via the sustina-esg-xbrl-processor Lambda.
 * The Lambda expects { action, payload: { taxonomyUrl, bucket, outputKey } };
 * the caller only supplies the entry-point URL, everything else is derived here.
 */
export const ingestTaxonomy = ({ entryPointPath, ...rest }) => {
  const slug = slugFromEntryPointUrl(entryPointPath);
  return executeWorkflowHandshake(
    "doorman/IngestTaxonomy",
    {
      action: "INGEST_XBRL_TAXONOMY",
      payload: {
        taxonomyUrl: entryPointPath,
        bucket: TAXONOMY_BUCKET,
        outputKey: `taxonomies/${slug}/concept-catalogue.json`,
        ...rest
      }
    },
    "IngestTaxonomy"
  );
};

/**
 * Generates an XBRL filing instance from a template/bindings payload via the same Lambda.
 */
export const generateFiling = (payload) =>
  executeWorkflowHandshake(
    "doorman/GenerateFiling",
    { action: "GENERATE_XBRL_FILING", ...payload },
    "GenerateFiling"
  );
